import React from "react";
import { createPortal } from "react-dom";
import styles from "./BrandingOverlay.module.css";

interface BrandingOverlayProps {
    show: boolean;
    logoSrc: string;
}

const BrandingOverlay: React.FC<BrandingOverlayProps> = ({ show, logoSrc }) => {
    if (!show) return null;

    return createPortal(
        <div className={styles.overlay}>
            <img src={logoSrc} alt="Logo" className={styles.logo} />
        </div>,
        document.body,
    );
};

export default BrandingOverlay;
